module.exports = __webpack_public_path__ + "img/会员中心顶部图.3e9a1c01.png";